
import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { formatRepeatingOrdersUnavailableDates, formatRepeatingOrdersUnavailableDatesListHtml } from '@/utils/format';
import InfoBanner from '@/components/shared/InfoBanner.vue';

const namespace: string = 'cart';

@Component<CartBanners>({
	components: {
		InfoBanner
	}
})
export default class CartBanners extends Vue {
	@Getter('getWarning', { namespace }) private warning!: CostsWarning | null;
	@Getter('getMemberInfo', { namespace }) private memberInfo!: CheckoutMemberInfo;
	@Getter('haveCostsBeenSet', { namespace }) private haveCostsBeenSet!: boolean;
	@Getter('getMemberDiscountCode', { namespace }) private memberDiscountCode!: string[];
	@Getter('getMembershipDiscounts', { namespace }) private membershipDiscounts!: (PunchhPromo | MemberPromo)[];
	@Getter('getRepeatingOrdersUnavailableDates', { namespace: 'restaurant' }) private repeatingOrdersUnavailableDates!: string[];
	@Getter('getRepeatingOrdersSelectedMealType', { namespace: 'restaurant' }) private repeatingOrdersSelectedMealType!: string;

	/**
	 * Format repeating orders unavailable dates for display (when 3 or fewer)
	 *
	 * @return {string}
	 */
	private get formattedUnavailableDates(): string {
		return formatRepeatingOrdersUnavailableDates(this.repeatingOrdersUnavailableDates);
	}

	/**
	 * Generate HTML for repeating orders unavailable dates list (when more than 3)
	 *
	 * @return {string}
	 */
	private get unavailableDatesListHtml(): string {
		return formatRepeatingOrdersUnavailableDatesListHtml(this.repeatingOrdersUnavailableDates, this.repeatingOrdersSelectedMealType);
	}

	private get unappliedDiscountNames(): string[] {
		if (!this.haveCostsBeenSet || !this.memberInfo?.promosApplied?.size || this.memberInfo.provider !== 'Punchh') {
			return [];
		}
		return this.membershipDiscounts
			.filter((d): d is PunchhPromo => 'name' in d && this.memberInfo.promosApplied.has(d.id) && !this.memberDiscountCode?.includes(d.name))
			.map(d => d.name);
	}

	/**
	 * Formats the parameters of the i18n warning string if needed.
	 * Currently only formats currency amounts.
	 *
	 * @param {Record<string, any>} [params]
	 * @return {Record<string, any>}
	 */
	private formatWarningParams(params?: Record<string, any>): Record<string, any> {
		return {
			...params,
			...(!!params?.amount && { amount: this.$n(params.amount, 'currency') }),
			...(!!params?.left && { left: this.$n(params.left, 'currency') })
		};
	}
}
